/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Number_Of_EventsInputs */



/**
* | output |
* | --- |
* | "Number of events" |
*
* @param {Editor_Number_Of_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_number_of_events = /** @type {((inputs?: Editor_Number_Of_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Number_Of_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件数量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं की संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de eventos")
	return /** @type {LocalizedString} */ ("Number of events")
});